<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addTransportInfo">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="locations"
          :title="$t('LOCATIONS') || '地区'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="baseWeight"
          :title="$t('BASE_WEIGHT') || '首重'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="postage"
          :title="$t('POSTAGE') || '运费'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="unitWeight"
          :title="$t('UNIT_WEIGHT') || '续重'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="unitPostage"
          :title="$t('UNIT_POSTAGE') || '续费'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
              <a-button type="link" @click="editTransportInfo(record.id)">{{ $t('EDIT') || '编辑' }} </a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="deleteTransportInfo(record.id)">删除</a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="运输信息编辑"
      v-model="form.visible">
      <transportInfo-edit
        v-if="form.visible"
        :transport-info-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </transportInfo-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryTransportInfos,
  _deleteTransportInfo,
} from '@/api/transportInfoApi';
import TransportInfoEdit from './TransportInfoEdit.vue';

async function getTransportInfoList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryTransportInfos({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addTransportInfo() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editTransportInfo(transportInfoId) {
  this.form.data.id = transportInfoId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getTransportInfoList();
}

async function deleteTransportInfo(transportInfoId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteTransportInfo(transportInfoId);
      this.$message.success('删除成功');
      await this.getTransportInfoList();
    },
  });
}

export default {
  name: 'TransportInfoList',
  components: { TransportInfoEdit },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getTransportInfoList,
    deleteTransportInfo,
    editTransportInfo,
    addTransportInfo,
    closeForm,
  },
  created() {
    this.getTransportInfoList();
  },
};
</script>

<style scoped>

</style>
